__turbopack_context__.v({
  "closeButton": "PlaceCard-module__OyUska__closeButton",
  "container": "PlaceCard-module__OyUska__container",
  "contentArea": "PlaceCard-module__OyUska__contentArea",
  "contentWrapper": "PlaceCard-module__OyUska__contentWrapper",
  "cta": "PlaceCard-module__OyUska__cta",
  "ctaWrapper": "PlaceCard-module__OyUska__ctaWrapper",
  "dayRange": "PlaceCard-module__OyUska__dayRange",
  "description": "PlaceCard-module__OyUska__description",
  "error": "PlaceCard-module__OyUska__error",
  "errorsContainer": "PlaceCard-module__OyUska__errorsContainer",
  "image": "PlaceCard-module__OyUska__image",
  "locations": "PlaceCard-module__OyUska__locations",
  "markdown": "PlaceCard-module__OyUska__markdown",
  "subtitle": "PlaceCard-module__OyUska__subtitle",
  "suggestionItem": "PlaceCard-module__OyUska__suggestionItem",
  "suggestionsList": "PlaceCard-module__OyUska__suggestionsList",
  "suggestionsTitle": "PlaceCard-module__OyUska__suggestionsTitle",
  "title": "PlaceCard-module__OyUska__title",
});
